/* import __COLOCATED_TEMPLATE__ from './ongoing-registrations.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';

import styles from './ongoing-registrations.module.css';

export default class ResumeOngoingRegistrationsComponent extends Component {
  styles = styles;

  @service deviceManager;
}
